module.exports = __webpack_public_path__ + "img/11n.adbe5f9a.svg";